var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PropTypes } from 'react';

var FormFieldError = function (_React$Component) {
  _inherits(FormFieldError, _React$Component);

  function FormFieldError() {
    _classCallCheck(this, FormFieldError);

    return _possibleConstructorReturn(this, (FormFieldError.__proto__ || Object.getPrototypeOf(FormFieldError)).apply(this, arguments));
  }

  _createClass(FormFieldError, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.field.invalid) {
        return null;
      }

      return React.createElement(
        "div",
        { className: "cf-form__field-error" },
        Object.keys(this.props.validations).map(function (validation) {
          return React.createElement(
            "p",
            { key: validation },
            _this2.props.validations[validation]
          );
        })
      );
    }
  }]);

  return FormFieldError;
}(React.Component);

FormFieldError.propTypes = {
  field: PropTypes.object.isRequired,
  validations: PropTypes.object.isRequired
};

export default FormFieldError;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-form/es/FormFieldError.js
// module id = 840
// module chunks = 0